export enum RouteEditTab {
  Ftl,
  Ltl,
}
